import styled from 'styled-components';

/* Chrome, Safari, Edge, Opera */
// input[type=number].sin-flechas::-webkit-inner-spin-button, 
// input[type=number].sin-flechas::-webkit-outer-spin-button { 
//     -webkit-appearance: none; 
//     margin: 0; 
// }
/* Firefox */
// input[type=number].sin-flechas{
//     -moz-appearance: textfield;
// }
const Input = styled.input`
    ::-webkit-inner-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    }
    ::-webkit-outer-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    }    
`;

const InputNumber = ({value, setValue, name, onChange, className}) => {

    return (
        <Input
            type="number"
            className={"form-control form-control-sm " + className}
            onChange={onChange || (e => setValue(e.target.value))}
            value={value}
            name={name}
        />
    )
    
};
export default InputNumber;